import "./column-components.298cc9f3.js";
import {Component as $OHKlF$Component} from "react";
import {findDOMNode as $OHKlF$findDOMNode} from "react-dom";
import $OHKlF$uibox from "ui-box";
import $OHKlF$macrostrathyper from "@macrostrat/hyper";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $4cfd4c889e62287b$exports = {};

$parcel$export($4cfd4c889e62287b$exports, "ColumnScroller", () => $4cfd4c889e62287b$export$e60368c40bae9fd4);





var $aVUB5 = parcelRequire("aVUB5");
const $4cfd4c889e62287b$var$splitProps = function(keys, props) {
    const obj = {};
    const rest = {};
    for(let k in props){
        const v = props[k];
        if (keys.includes(k)) obj[k] = v;
        else rest[k] = v;
    }
    return [
        obj,
        rest
    ];
};
class $4cfd4c889e62287b$export$e60368c40bae9fd4 extends (0, $OHKlF$Component) {
    constructor(props){
        super(props);
        this.scrollTo = this.scrollTo.bind(this);
    }
    static #_ = this.defaultProps = {
        animated: true,
        alignment: "center",
        onScrolled (height) {
            return console.log(`Scrolled to ${height} m`);
        },
        scrollContainer () {
            return document.querySelector(".panel-container");
        }
    };
    static #_2 = this.contextType = (0, $aVUB5.ColumnContext);
    render() {
        const keys = [
            "scrollToHeight",
            "alignment",
            "animated",
            "onScrolled",
            "paddingTop",
            "scrollContainer"
        ];
        const [props, rest] = $4cfd4c889e62287b$var$splitProps(keys, this.props);
        const { pixelHeight: pixelHeight } = this.context;
        return (0, $OHKlF$macrostrathyper)((0, $OHKlF$uibox), {
            height: pixelHeight,
            position: "absolute",
            ...rest
        });
    }
    scrollTo(height, opts = {}) {
        let node = (0, $OHKlF$findDOMNode)(this);
        let { animated: animated, alignment: alignment, ...rest } = opts;
        if (animated == null) animated = false;
        const { paddingTop: paddingTop } = this.props;
        const { scale: scale } = this.context;
        const pixelOffset = scale(height);
        const { top: top } = node.getBoundingClientRect();
        node = this.props.scrollContainer();
        let pos = pixelOffset + top + paddingTop;
        const screenHeight = window.innerHeight;
        if (this.props.alignment === "center") pos -= screenHeight / 2;
        else if (this.props.alignment === "bottom") pos -= screenHeight;
        return node.scrollTop = pos;
    }
    componentDidMount() {
        const { scrollToHeight: scrollToHeight, alignment: alignment } = this.props;
        if (scrollToHeight == null) return;
        this.scrollTo(scrollToHeight, {
            alignment: alignment,
            animated: false
        });
        return this.props.onScrolled(scrollToHeight);
    }
    componentDidUpdate(prevProps) {
        const { scrollToHeight: scrollToHeight, animated: animated, alignment: alignment } = this.props;
        if (scrollToHeight == null) return;
        if (prevProps.scrollToHeight === scrollToHeight) return;
        this.scrollTo(scrollToHeight, {
            alignment: alignment,
            animated: animated
        });
        return this.props.onScrolled(scrollToHeight);
    }
}


export {$4cfd4c889e62287b$export$e60368c40bae9fd4 as ColumnScroller};
//# sourceMappingURL=column-components.c709c904.js.map
